<div
  id="standard-modal"
  role="dialog"
  aria-labelledby="standard-modalLabel"
  aria-hidden="true"
  [hidden]="step !== 1"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <div class="d-flex flex-column alin-items-start">
          <h4 class="modal-title" id="standard-modalLabel">
            {{ 'attendance.crmPipedrive.integrationTitle' | translate }}
          </h4>
          <span class="h6">
            {{ 'attendance.crmPipedrive.integrationSubtitle' | translate }}
          </span>
        </div>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
          (click)="openDialogCrm(attendance)"
        ></button>
      </div>
      <div class="modal-body">
        <mat-select
          (selectionChange)="integrationSelection($event)"
          class="form-control"
          [placeholder]="'attendance.crmPipedrive.selectIntegration' | translate"
        >
          @for(token of apiToken; track $index) {
          <mat-option [value]="token.value">
            {{ token.label }}
          </mat-option>
          }
        </mat-select>
      </div>

      <div class="modal-footer">
        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-secondary me-2"
            (click)="openDialogCrm(attendance)"
          >
            {{ 'attendance.crmPipedrive.close' | translate }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            [disabled]="!selectedIntegrationApiToken"
            (click)="nextStepLeadsTwo()"
          >
            {{ 'attendance.crmPipedrive.confirm' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  id="standard-modal"
  role="dialog"
  aria-labelledby="standard-modalLabel"
  aria-hidden="true"
  [hidden]="step !== 2"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <div class="d-flex flex-column alin-items-start">
          <h4 class="modal-title" id="standard-modalLabel">
            {{ 'attendance.crmPipedrive.actionsTitle' | translate }}
          </h4>
          <span class="h6">
            {{ 'attendance.crmPipedrive.actionsSubtitle' | translate }}
          </span>
        </div>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
          (click)="openDialogCrm(attendance)"
        ></button>
      </div>
      <div class="modal-body">
        <div class="d-flex flex-wrap align-items-center gap-2 mt-3 col-12">
          <div class="col-3">
            <div
              class="card"
              style="cursor: pointer; height: 148px"
              (click)="nextStepLeadsThree()"
            >
              <div class="card-body">
                <div class="d-flex justify-content-center mb-3">
                  <div class="icon-wrapper icon-wrapper--official">
                    <i
                      class="mdi mdi-briefcase-account-outline icon-wrapper__icon"
                    ></i>
                  </div>
                </div>
                <div class="d-flex justify-content-center">
                  <h5 class="card-title">Leads</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div
              class="card"
              style="cursor: pointer; height: 148px"
              (click)="nextStepLeadsFour()"
            >
              <div class="card-body">
                <div class="d-flex justify-content-center mb-3">
                  <div class="icon-wrapper icon-wrapper--official">
                    <i
                      class="mdi mdi-account-circle-outline icon-wrapper__icon"
                    ></i>
                  </div>
                </div>
                <div class="d-flex justify-content-center">
                  <h5 class="card-title">{{ 'attendance.crmPipedrive.person' | translate }}</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div
              class="card"
              style="cursor: pointer; height: 148px"
              (click)="nextStepLeadsFive()"
            >
              <div class="card-body">
                <div class="d-flex justify-content-center mb-3">
                  <div class="icon-wrapper icon-wrapper--official">
                    <i class="mdi mdi-handshake-outline icon-wrapper__icon"></i>
                  </div>
                </div>
                <div class="d-flex justify-content-center">
                  <h5 class="card-title">Deal</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div
              class="card"
              style="cursor: pointer; height: 148px"
              (click)="nextStepLeadsSix()"
            >
              <div class="card-body">
                <div class="d-flex justify-content-center mb-3">
                  <div class="icon-wrapper icon-wrapper--official">
                    <i
                      class="mdi mdi-account-group-outline icon-wrapper__icon"
                    ></i>
                  </div>
                </div>
                <div class="d-flex justify-content-center">
                  <h5 class="card-title">{{ 'attendance.crmPipedrive.personAndDeals' | translate }}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  id="standard-modal"
  role="dialog"
  aria-labelledby="standard-modalLabel"
  aria-hidden="true"
  [hidden]="step !== 3"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <div class="d-flex flex-column alin-items-start">
          <h4 class="modal-title" id="standard-modalLabel">
            {{ 'attendance.crmPipedrive.createLeadTitle' | translate }}
          </h4>
          <span class="h6">
            {{ 'attendance.crmPipedrive.selectResponsibleOptionalMessage' | translate }}
          </span>
        </div>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
          (click)="clearValuesToBack()"
        ></button>
      </div>
      <div class="modal-body">
        <mat-select
          (selectionChange)="usersSelection($event)"
          class="form-control mb-4"
          [placeholder]="'attendance.crmPipedrive.selectResponsible' | translate"
        >
          @for(option of usersOptions; track $index) {
          <mat-option [value]="option">
            {{ option.label }}
          </mat-option>
          }
        </mat-select>
        <form [formGroup]="formGroup" class="mt-3">
          <div class="custom-switch col-12">
            <input
              type="checkbox"
              id="lead-history"
              checked
              data-switch="success"
              formControlName="sendMessageHistory"
              (change)="sendHistoryChange($event)"
            />
            <label for="lead-history">
              <span>{{ 'attendance.crmPipedrive.sendConversation' | translate }}</span>
            </label>
          </div>
          <small class="text-muted">
            {{ 'attendance.crmPipedrive.sendConversationHistory' | translate }}
          </small>
        </form>
      </div>

      <div class="modal-footer">
        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-secondary me-2"
            (click)="clearValuesToBack()"
          >
            {{ 'attendance.crmPipedrive.cancel' | translate }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            [disabled]="loading"
            (click)="sendDataPersonLead()"
          >
            @if(loading) {
            <mat-spinner
              diameter="25"
              [color]="'accent'"
              mode="indeterminate"
            ></mat-spinner>
            }
            <span>{{ loading ? "" : ('attendance.crmPipedrive.confirm' | translate) }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  id="standard-modal"
  role="dialog"
  aria-labelledby="standard-modalLabel"
  aria-hidden="true"
  [hidden]="step !== 4"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <div class="d-flex flex-column alin-items-start">
          <h4 class="modal-title" id="standard-modalLabel">
            {{ 'attendance.crmPipedrive.createPersonTitle' | translate }}
          </h4>
          <span class="h6">
            {{ 'attendance.crmPipedrive.selectResponsibleOptionalMessage' | translate }}
          </span>
        </div>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
          (click)="clearValuesToBack()"
        ></button>
      </div>
      <div>
        <mat-select
          (selectionChange)="usersSelection($event)"
          class="form-control"
          [placeholder]="'attendance.crmPipedrive.selectResponsible' | translate"
        >
          @for(option of usersOptions; track $index) {
          <mat-option [value]="option">
            {{ option.label }}
          </mat-option>
          }
        </mat-select>
        <form [formGroup]="formGroup" class="mt-3">
          <div class="custom-switch col-12">
            <input
              type="checkbox"
              id="person-history"
              checked
              data-switch="success"
              formControlName="sendMessageHistory"
              (change)="sendHistoryChange($event)"
            />
            <label for="person-history">
              <span>{{ 'attendance.crmPipedrive.sendConversation' | translate }}</span>
            </label>
          </div>
          <small class="text-muted">
            {{ 'attendance.crmPipedrive.sendConversationHistory' | translate }}
          </small>
        </form>
      </div>
      <div class="modal-footer">
        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-secondary me-2"
            (click)="clearValuesToBack()"
          >
            {{ 'attendance.crmPipedrive.cancel' | translate }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            [disabled]="loading"
            (click)="sendDataPerson()"
          >
            @if(loading) {
            <mat-spinner
              diameter="25"
              [color]="'accent'"
              mode="indeterminate"
            ></mat-spinner>
            }
            <span>{{ loading ? "" : ('attendance.crmPipedrive.confirm' | translate) }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  id="standard-modal"
  role="dialog"
  aria-labelledby="standard-modalLabel"
  aria-hidden="true"
  [hidden]="step !== 5"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <div class="d-flex flex-column alin-items-start">
          <h4 class="modal-title" id="standard-modalLabel">
            {{ 'attendance.crmPipedrive.createDealTitle' | translate }}
          </h4>
          <span class="h6">
            {{ 'attendance.crmPipedrive.selectPipelineStageResponsibleOptionalMessage' | translate }}
          </span>
        </div>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
          (click)="clearValuesToBack()"
        ></button>
      </div>
      <div class="modal-body d-flex flex-column gap-3">
        <mat-select
          class="form-control"
          [(ngModel)]="selectedPipeline"
          (selectionChange)="stageSelect()"
          [placeholder]="'attendance.crmPipedrive.selectPipeline' | translate"
        >
          @for(option of pipelinesOptions; track $index) {
          <mat-option [value]="option.value">
            {{ option.label }}
          </mat-option>
          }
        </mat-select>
        <mat-select
          class="form-control"
          [(ngModel)]="selectedStage"
          [disabled]="!selectedPipeline"
          [placeholder]="'attendance.crmPipedrive.selectStage' | translate"
        >
          @for(option of stagesOptions; track $index) {
          <mat-option [value]="option.value">
            {{ option.label }}
          </mat-option>
          }
        </mat-select>
        <mat-select
          class="form-control"
          (selectionChange)="usersSelection($event)"
          [placeholder]="'attendance.crmPipedrive.selectResponsible' | translate"
        >
          @for(option of usersOptions; track $index) {
          <mat-option [value]="option">
            {{ option.label }}
          </mat-option>
          }
        </mat-select>
        <form [formGroup]="formGroup" class="mt-3">
          <div class="custom-switch col-12">
            <input
              type="checkbox"
              id="deal-history"
              checked
              data-switch="success"
              formControlName="sendMessageHistory"
              (change)="sendHistoryChange($event)"
            />
            <label for="deal-history">
              <span>{{ 'attendance.crmPipedrive.sendConversation' | translate }}</span>
            </label>
          </div>
          <small class="text-muted">
            {{ 'attendance.crmPipedrive.sendConversationHistory' | translate }}
          </small>
        </form>
      </div>
      <div class="modal-footer">
        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-secondary me-2"
            (click)="clearValuesToBack()"
          >
            {{ 'attendance.crmPipedrive.cancel' | translate }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            [disabled]="loading"
            (click)="sendDataDeal()"
          >
            @if(loading) {
            <mat-spinner
              diameter="25"
              [color]="'accent'"
              mode="indeterminate"
            ></mat-spinner>
            }
            <span>{{ loading ? "" : ('attendance.crmPipedrive.confirm' | translate) }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  id="standard-modal"
  role="dialog"
  aria-labelledby="standard-modalLabel"
  aria-hidden="true"
  [hidden]="step !== 6"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <div class="d-flex flex-column alin-items-start">
          <h4 class="modal-title" id="standard-modalLabel">
            {{ 'attendance.crmPipedrive.createPersonAndDealTitle' | translate }}
          </h4>
          <span class="h6">
            {{ 'attendance.crmPipedrive.selectPipelineStageResponsibleOptionalMessage' | translate }}
          </span>
        </div>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
          (click)="clearValuesToBack()"
        ></button>
      </div>
      <div class="modal-body d-flex flex-column gap-3">
        <mat-select
          class="form-control"
          [(ngModel)]="selectedPipeline"
          (selectionChange)="stageSelect()"
          [placeholder]="'attendance.crmPipedrive.selectPipeline' | translate"
        >
          @for(option of pipelinesOptions; track $index) {
          <mat-option [value]="option.value">
            {{ option.label }}
          </mat-option>
          }
        </mat-select>
        <mat-select
          class="form-control"
          [(ngModel)]="selectedStage"
          [disabled]="!selectedPipeline"
          [placeholder]="'attendance.crmPipedrive.selectStage' | translate"
        >
          @for(option of stagesOptions; track $index) {
          <mat-option [value]="option.value">
            {{ option.label }}
          </mat-option>
          }
        </mat-select>
        <mat-select
          class="form-control"
          (selectionChange)="usersSelection($event)"
          [placeholder]="'attendance.crmPipedrive.selectResponsible' | translate"
        >
          @for(option of usersOptions; track $index) {
          <mat-option [value]="option">
            {{ option.label }}
          </mat-option>
          }
        </mat-select>
        <form [formGroup]="formGroup" class="mt-3">
          <div class="custom-switch col-12">
            <input
              type="checkbox"
              id="person-deal-history"
              checked
              data-switch="success"
              formControlName="sendMessageHistory"
              (change)="sendHistoryChange($event)"
            />
            <label for="person-deal-history">
              <span>{{ 'attendance.crmPipedrive.sendConversation' | translate }}</span>
            </label>
          </div>
          <small class="text-muted">
            {{ 'attendance.crmPipedrive.sendConversationHistory' | translate }}
          </small>
        </form>
      </div>
      <div class="modal-footer">
        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-secondary me-2"
            (click)="clearValuesToBack()"
          >
            {{ 'attendance.crmPipedrive.cancel' | translate }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            [disabled]="loading"
            (click)="sendDataPersonDeal()"
          >
            @if(loading) {
            <mat-spinner
              diameter="25"
              [color]="'accent'"
              mode="indeterminate"
            ></mat-spinner>
            }
            <span>{{ loading ? "" : ('attendance.crmPipedrive.confirm' | translate) }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
